import { Injectable } from '@angular/core';
import { BrandModel, BrandViewModel, CompetenceByBrandResponseModel } from '../business-entities/brand-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { BrandDataService } from '../data-services/brand-data.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';

@Injectable({
    providedIn: 'root'
})

export class BrandService {
    brandId;
    brandModel: BrandViewModel;
    brandList: BrandViewModel[];
    competenceModel: CompetenceByBrandResponseModel;
    constructor(private service: BrandDataService) {
    }

    async getBrand(): Promise<any> {
        await this.service
            .getBrand()
            .then(
                (res: GenericResponse<Array<BrandViewModel>>) => {
                    this.brandList = res.responseObject;
                }
            );

        return this.brandList;
    }

    AddBrand(model: BrandModel): Promise<GenericResponse<any>> {
        return this.service.AddBrand(model);
    }

    async GetBrandById(Id: number): Promise<any> {
        await this.service
            .GetBrandById(Id)
            .then(
                (res: GenericResponse<BrandViewModel>) => {
                    this.brandModel = res.responseObject;
                }
            );
        return this.brandModel;
    }

    EditBrand(Model: BrandModel): Promise<GenericResponse<any>> {
        return this.service.EditBrand(Model);
    }

    DeleteBrand(Id: number) {
        return this.service.DeleteBrand(Id);
    }

    async GetCompetenceByBrandId(Id: number): Promise<any> {
        await this.service
            .GetCompetenceByBrandId(Id)
            .then(
                (res: GenericResponse<CompetenceByBrandResponseModel>) => {
                    this.competenceModel = res.responseObject;
                }
            );
        return this.competenceModel;
    }

    async GetBrandDropdown():Promise<any>{
        return this.service.GetBrandDropdown();
    }
    async GetBrandDropdownResult():Promise<any>{
        let brands = [];
        await this.service.GetBrandDropdown().then(data => {
            if (data?.responseCode === Enums.ErrorCodes.SuccessCode)
           { brands = data.responseObject;}
          });
        return brands;
    }

    async GetModelnoDropdownList(brand:string):Promise<any>{
        return this.service.GetModelnoDropdownList(brand);
    }
   
    async GetServiceBrandDropdownList(brandCode:string):Promise<any>{
        return this.service.GetServiceBrandDropdownList(brandCode);
    }
}
